import type {RefreshToken} from '../../types'

const initialState: RefreshToken = {
  isLoading: false,
  authError: '',
  isTokenRefreshed: false,
}

export default (state: RefreshToken = initialState, action): RefreshToken => {
  const {type, payload} = action

  switch (type) {
    case 'REFRESH_TOKEN':
      return {
        ...state,
        isLoading: true,
        isTokenRefreshed: false,
      }
    case 'REFRESH_TOKEN_SUCCESS':
      if (payload && payload.token) {
        return {
          ...state,
          isLoading: false,
          authError: '',
          isTokenRefreshed: true,
        }
      }
      return {
        ...state,
        isLoading: false,
        authError: 'Please enter correct password.',
        isTokenRefreshed: false,
      }
    case 'REFRESH_TOKEN_FAILURE':
      return {
        ...state,
        isLoading: false,
        authError: 'Error in authenticating the user, please try again later.',
        isTokenRefreshed: false,
      }
    case 'RESET_REFRESH_TOKEN_FLAG':
      return initialState
    case 'LOG_OUT':
      return initialState
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/refresh-token/reducer.js